<template>
  <div
    v-if="gagnantsMajeurs && (gagnantsMajeurs.length == 0 || gagnantsMajeurs.length == null)"
    :class="[jel_getClassObject(content)]"
    :data-component-name="$options.name"
    class="container row d-flex justify-content-center texte"
  >
    {{ $t('messageComponent.resultatsIndisponibles') }}
  </div>
  <div v-else-if="gagnantsMajeurs" :data-component-name="$options.name">
    <ListeHorizontale :content="contentListeHorizontale" />
  </div>
  <div v-else :data-component-name="$options.name" class="container row texte">
    {{ $t('messageComponent.chargementEnCours') }}
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ListeHorizontale from '@/components/container/liste/ListeHorizontale';

export default {
  name: 'BingoGagnantMajeurListe',
  components: {
    ListeHorizontale,
  },
  props: {
    content: { type: Object, required: true },
  },
  i18n: {
    // `i18n` option, setup locale info for component
    messages: {
      fr: {
        messageComponent: {
          chargementEnCours: 'Chargement en cours...',
          resultatsIndisponibles: 'Résultats indisponibles',
        },
      },
      en: {
        messageComponent: {
          chargementEnCours: 'Loading...',
          resultatsIndisponibles: 'Unavailable results',
        },
      },
    },
  },
  computed: {
    ...mapGetters('bingo', ['getGagnantsMajeurs']),
    gagnantsMajeurs() {
      return this.getGagnantsMajeurs();
    },
    contentListeHorizontale() {
      if (!this.gagnantsMajeurs) {
        return {};
      }

      const nodes = [];

      const arrItems = {};
      this.gagnantsMajeurs.forEach((item, index) => {
        item.classeCSS = 'w-100 d-flex';
        item['mgnl:template'] = 'jel-lm:components/bingo/BingoGagnantMajeur';
        arrItems[index] = item;
        nodes.push(index);
      });

      arrItems['@nodes'] = nodes;

      const content = {
        listeHorizontale: arrItems,
        defilementAutomatique: this.content.defilementAutomatique,
        nbMaxElementAffiche: 50,
        restreindreLargeur: 'true',
        nbColMobile: 1,
        nbColTablette: 4,
        nbColDesktop: 5,
      };
      return content;
    },
  },
  mounted() {
    this.$store.dispatch('bingo/initGagnantMajeurs');
  },
};
</script>

<style lang="scss" scoped>
::v-deep .row {
  background-position: center;
  background-repeat: no-repeat;
}
::v-deep .row.bgcover {
  background-size: cover;
}
::v-deep .container-fluid {
  padding: 0;
}
::v-deep .container_media_bingo {
  border-style: none;
  display: flex;
  height: 100%;
}

::v-deep .container-gagnant-majeur {
  padding-top: 5%;
}

::v-deep .vhl-item-container {
  @include media-breakpoint-down(sm) {
    margin-left: 10%;
    margin-right: 10%;
  }
}

::v-deep .vhl-item {
  height: 100%;
  padding-top: 6rem;
  @include media-breakpoint-down(sm) {
    padding-top: 6rem;
    max-width: 50%;
  }
}

.push-liste-down {
  margin-top: -4rem;
}

.texte {
  @include ms-respond(font-size, 1);
}
</style>
